const KEY = "lifegrid.uid";

export function getUserId() {
  let uid = localStorage.getItem(KEY);
  if (!uid) {
    uid = "u_" + Math.random().toString(36).slice(2, 10) + Date.now().toString(36);
    localStorage.setItem(KEY, uid);
  }
  return uid;
}
